export default __webpack_public_path__ + "static/media/Boots of Erlik.96b1e357.jpg";